import classNames from "classnames";
import { PhosphorEye, PhosphorInfo } from "components/Atoms/PhosphorIcon";
import React from "react";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";
import { AdvancingRowIcon, phaseIcons, type RowIcon } from "./AdvancingRowIcon";
import { AdvancingRowPopup } from "./AdvancingRowPopup";
import { AdvancingSectionField } from "./types";

const readonlyIcon: RowIcon = { icon: PhosphorInfo, className: "readonly" };
const optionalIcon: RowIcon = { icon: PhosphorEye, className: "optional" };

interface Props {
  field: AdvancingSectionField
  onRemove?: () => void
}

export const AdvancingFieldLabel = ({ field, onRemove }: Props) => {
  const hasSublabel = field.sublabel != null;
  const hasPopup = field.phase !== "unknown" || onRemove;
  const rowIcon = field.formElementBehavior === "disabled"
    ? readonlyIcon
    : field.phase === "unknown" && field.formElementBehavior === "visibleOptional" ? optionalIcon : phaseIcons[field.phase];

  const iconElement = <div className={classNames("advancing-section-template-icon", { "advancing-section-template-icon-button": hasPopup })}>
    <AdvancingRowIcon rowIcon={rowIcon} />
  </div>;

  return <>
    {hasPopup
      ? <AdvancingRowPopup field={field} trigger={iconElement} onRemove={onRemove} />
      : iconElement}
    <div title={field.labelTitle} ref={field.ref} className={classNames("main-section-template-fields-label", field.labelClassName, {
      "flex gap": field.supportArticleId,
      "sublabel": hasSublabel
    })}>
      {field.label}
      {field.supportArticleId && <SupportQuestionMark small articleId={field.supportArticleId} />}
      {hasSublabel && <div className="s1_small">{field.sublabel}</div>}
    </div>
  </>
}
